import { ENDPOINTS } from "@/api/endpoints";
import { apiClient } from "@/lib/client";
import { DataSource, UploadedSessionData } from "@/types/common.types";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

type UploadStyleIdsFromUrlVariables = {
  url: string;
  jobName: string;
  dataSource: DataSource;
};

type UploadStyleIdsFromUrlResponse = UploadedSessionData & {
  userId: number;
  uploadTime: string;
  inputType: string;
  originalFileName: string;
  storageFileName: null;
  status: string;
  createdBy: null;
  createdDate: string;
  lastModifiedBy: null;
  lastModifiedAt: string;
  uploadedStyles: [];
};

const uploadStyleIdsFromUrl = async ({
  url,
  jobName,
  dataSource,
}: UploadStyleIdsFromUrlVariables): Promise<UploadStyleIdsFromUrlResponse> => {
  return apiClient
    .post(ENDPOINTS.UPLOAD_STYLE_IDS_BY_URL, {
      json: { url: url.trim(), jobName, dataSource },
      timeout: 120000,
    })
    .json<UploadStyleIdsFromUrlResponse>();
};

export const useUploadStyleIdsFromUrlMutation = (
  options?: UseMutationOptions<
    UploadStyleIdsFromUrlResponse,
    Error,
    UploadStyleIdsFromUrlVariables
  >
) => {
  return useMutation({
    mutationFn: uploadStyleIdsFromUrl,
    ...options,
  });
};
